module.exports = __webpack_public_path__ + "static/the-team-became-inviz-05411184f2aca556660a8e190682dcea.png";